import React from "react";
// camera house image
import cameraImageLg from "../../../images/websites/camera-house-large.png";
import cameraImageSm from "../../../images/websites/camera-house-small.png";
import cameraImageOne from "../../../images/websites/camera-house-desktop-one.png";
import cameraImageTwo from "../../../images/websites/camera-house-desktop-two.png";
import cameraImageThree from "../../../images/websites/camera-house-desktop-three.png";
import cameraImageFour from "../../../images/websites/camera-house-mobile-one.png";
import cameraImageFive from "../../../images/websites/camera-house-mobile-two.png";
import cameraImageSix from "../../../images/websites/camera-house-mobile-three.png";
// jibon image
import jibonImageLg from "../../../images/websites/jibon-large.png";
import jibonImageSm from "../../../images/websites/jibon-small.png";
import jibonImageOne from "../../../images/websites/jibon-desktop-one.png";
import jibonImageTwo from "../../../images/websites/jibon-desktop-two.png";
import jibonImageThree from "../../../images/websites/jibon-desktop-three.png";
import jibonImageFour from "../../../images/websites/jibon-mobile-one.png";
import jibonImageFive from "../../../images/websites/jibon-mobile-two.png";
import jibonImageSix from "../../../images/websites/jibon-mobile-three.png";
// tour e agency image
import tourImageLg from "../../../images/websites/tour-e-agency-large.png";
import tourImageSm from "../../../images/websites/tour-e-agency-small.png";
import tourImageOne from "../../../images/websites/tour-e-agency-desktop-one.png";
import tourImageTwo from "../../../images/websites/tour-e-agency-desktop-two.png";
import tourImageThree from "../../../images/websites/tour-e-agency-desktop-three.png";
import tourImageFour from "../../../images/websites/tour-e-agency-mobile-one.png";
import tourImageFive from "../../../images/websites/tour-e-agency-mobile-two.png";
import tourImageSix from "../../../images/websites/tour-e-agency-mobile-three.png";
// enstitute image
import enstituteImageLg from "../../../images/websites/e-nstitute-large.png";
import enstituteImageSm from "../../../images/websites/e-nstitute-small.png";
import enstituteImageOne from "../../../images/websites/e-nstitute-desktop-one.png";
import enstituteImageTwo from "../../../images/websites/e-nstitute-desktop-two.png";
import enstituteImageThree from "../../../images/websites/e-nstitute-desktop-three.png";
import enstituteImageFour from "../../../images/websites/e-nstitute-mobile-one.png";
import enstituteImageFive from "../../../images/websites/e-nstitute-mobile-two.png";
import enstituteImageSix from "../../../images/websites/e-nstitute-mobile-three.png";

const useProjectData = () => {
  const projectData = [
    {
      id: "pd-1",
      name: "Camera House",
      tech: "React/Material UI",
      techDetails: ["Firebase","MongoDB","React","Node.js","Material UI","Express","Heroku"],
      features: [
        "This is a online shop.",
        "There has secured profile system.",
        "You can manage products/orders.",
      ],
      liveSite: "https://camera-house-e359b.web.app/",
      github: "https://github.com/MRIEnan/Camera-House-client-side",
      photo: {
        imageLg: cameraImageLg,
        imageSm: cameraImageSm,
        imageOne: cameraImageOne,
        imageTwo: cameraImageTwo,
        imageThree: cameraImageThree,
        imageFour: cameraImageFour,
        imageFive: cameraImageFive,
        imageSix: cameraImageSix,
      },
    },
    {
      id: "pd-2",
      name: "Jibon",
      tech: "React/CSS",
      techDetails: ["Firebase","MongoDB","React","CSS","Node.js","Express","Heroku","IcoFont"],
      features: [
        "This is a health related webpage.",
        "There has secured profile system.",
        "You can know about the various medical condition.",
      ],
      liveSite: "https://jibon-firebase-auth.web.app/",
      github: "https://github.com/MRIEnan/Jibon-healthcare-client-side",
      photo: {
        imageLg: jibonImageLg,
        imageSm: jibonImageSm,
        imageOne: jibonImageOne,
        imageTwo: jibonImageTwo,
        imageThree: jibonImageThree,
        imageFour: jibonImageFour,
        imageFive: jibonImageFive,
        imageSix: jibonImageSix,
      },
    },
    {
      id: "pd-3",
      name: "Tour E Agency",
      tech: "React/CSS",
      techDetails: ["Firebase","MongoDB","React","Node.js","CSS","Express","Heroku","React Hook form"],
      features: [
        "This is a traveling website.",
        "There has secured profile system.",
        "You can get book tour of different places.",
      ],
      liveSite: "https://tour-e-e370e.web.app/",
      github: "https://github.com/MRIEnan/Tour-E-Agency-client-side",
      photo: {
        imageLg: tourImageLg,
        imageSm: tourImageSm,
        imageOne: tourImageOne,
        imageTwo: tourImageTwo,
        imageThree: tourImageThree,
        imageFour: tourImageFour,
        imageFive: tourImageFive,
        imageSix: tourImageSix,
      },
    },
    {
      id: "pd-4",
      name: "E-nstitute",
      tech: "React/Tailwind",
      techDetails: ["Netlify","React","Tailwind",],
      features: [
        "This is a institutional webpage.",
        "By this you can join this institute and start building your skills.",
        "You can know about this institute.",
      ],
      liveSite: "https://e-nstitute.netlify.app/",
      github: "https://github.com/MRIEnan/E-nstitute-client-side",
      photo: {
        imageLg: enstituteImageLg,
        imageSm: enstituteImageSm,
        imageOne: enstituteImageOne,
        imageTwo: enstituteImageTwo,
        imageThree: enstituteImageThree,
        imageFour: enstituteImageFour,
        imageFive: enstituteImageFive,
        imageSix: enstituteImageSix,
      },
    },
  ];
  return {projectData};
};

export default useProjectData;
